import React from 'react'

const NewResultError = () => {
    return (
        <>
            <div className="hidden lg:flex flex-col gap-4 items-center justify-center">
                <div className="size-[45px] text-[#e9ebec]">
                    <svg class="" viewBox="0 0.55 19 17.9"><path d="M18.6052 14.2482L11.8934 1.91017C10.8151 0.0947467 8.18636 0.0923347 7.10655 1.91017L0.395099 14.2482C-0.707272 16.1032 0.627367 18.4523 2.78799 18.4523H16.2118C18.3706 18.4523 19.7076 16.1051 18.6052 14.2482ZM9.5 16.2257C8.88628 16.2257 8.38671 15.7262 8.38671 15.1125C8.38671 14.4988 8.88628 13.9992 9.5 13.9992C10.1137 13.9992 10.6133 14.4988 10.6133 15.1125C10.6133 15.7262 10.1137 16.2257 9.5 16.2257ZM10.6133 11.7726C10.6133 12.3863 10.1137 12.8859 9.5 12.8859C8.88628 12.8859 8.38671 12.3863 8.38671 11.7726V6.20622C8.38671 5.5925 8.88628 5.09293 9.5 5.09293C10.1137 5.09293 10.6133 5.5925 10.6133 6.20622V11.7726Z" fill='currentColor'></path><defs><clipPath><rect></rect></clipPath></defs></svg>
                </div>
                <p className="text-sm font-nomal text-[#e9ebec] font-KoreanTITGD">해당기간 베팅내역이 없습니다.</p>
            </div>
        </>
    )
}

export default NewResultError